import Container from "./Container";

const About = () => {
  return (
    <div id="about" className="bg-3 py-20">
      <Container>
        <div className="max-w-[1000px] mx-auto">
          <h2 className="text-3xl font-bold text-center mb-8 h-color-2">
            ABOUT
          </h2>
          <section>
            <div className="md:flex items-center">
              <img
                className="object-contain w-[230px] h-[230px] rounded-full mx-auto"
                src="./profile.png"
                alt=""
              />
              <div className="ml-6">
                <p className=" sm:mt-4 p-color-2">
                  I blend tech and design to improve digital experiences,
                  prioritizing easy-to-use UI and clean code. Using my web
                  marketing experience, I carefully adjust websites to make them
                  more user-friendly and effective at driving conversions📈.
                  <br />
                </p>
                <p className="sm:mt-4 p-color-2">
                  I have a Bachelor of IT from{" "}
                  <a className="tertiary font-bold" href="https://koi.edu.au/">
                    King's Own Institute
                  </a>{" "}
                  🇦🇺, and a BA in English Language and Literature from{" "}
                  <a
                    className="tertiary font-bold"
                    href="https://www.kansaigaidai.ac.jp/en/"
                  >
                    Kansai Gaidai
                  </a>{" "}
                  🇯🇵
                </p>
                <p className="sm:mt-4 p-color-2">
                  Currently I'm working for{" "}
                  <a
                    className="tertiary font-bold"
                    href="https://thebreak.org.au/"
                  >
                    The break.inc
                  </a>
                  , a non-profit organization in 🇦🇺, I pour my skills in
                  frontend into developing web and mobile apps that aim to
                  tackle social issues and make a difference in people's lives.
                </p>
                <p className="sm:mt-4 p-color-2">
                  When not coding, I'm birdwatching 🦜, playing volleyball, or
                  diving into anime. I'm open to work, so feel free to message
                  me 🙂
                </p>
              </div>
            </div>
          </section>
        </div>
      </Container>
    </div>
  );
};

export default About;
